import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 mb-xl-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-1 pb-0" }, [
    /*#__PURE__*/_createTextVNode(" The electricity industry categorises meters according to the way in which energy is used during the day. There is a total of 9 different electricity meter profiles. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("The gas industry can categorise meters according to whether they are IGT (independent gas transported) or non IGT. IGT supplies are those which are supplied via private gas networks. Non IGT supplies are connected to the National Grid. ")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "card mb-xl-1" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "d-flex overflow-auto h-20x",
  style: {"float":"right"}
}
const _hoisted_7 = { id: "container" }
const _hoisted_8 = { class: "tabs" }
const _hoisted_9 = { class: "tab" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-box card-label",
  style: {"cursor":"pointer"}
}, " Graph(s) ", -1)
const _hoisted_11 = { class: "tab" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-box card-label",
  style: {"cursor":"pointer"}
}, " Table ", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  class: "card mb-5 mb-xl-5",
  id: "kt_profile_details_view"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header cursor-pointer\" style=\"float:right !important;\"><div class=\"card-title m-0 col-md-5\"><i class=\"bi-bar-chart-fill text-danger p-3\"></i><h3 class=\"fw-bolder m-0\">Electricity Meter Profile Breakdown</h3></div><div class=\"card-title m-0 col-md-5\"><i class=\"bi-bar-chart-fill text-danger p-3\"></i><h3 class=\"fw-bolder m-0\">Gas Meter Type Breakdown</h3></div></div>", 1)
const _hoisted_16 = { class: "card-body p-9" }
const _hoisted_17 = { class: "row mb-7" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar m-0" }, null, -1)
const _hoisted_19 = { class: "row col-md-12" }
const _hoisted_20 = {
  id: "chart",
  class: "row col-md-5"
}
const _hoisted_21 = {
  style: {"margin-left":"6% !important"},
  class: "\n                  nav nav-stretch\n                  fs-5\n                  fw-bold\n                  nav-line-tabs nav-line-tabs-2x\n                  border-transparent\n                ",
  role: "tablist"
}
const _hoisted_22 = {
  class: "nav-item",
  role: "presentation",
  style: {"float":"right"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chart-pie fa-lg fa-border-none",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-undo fa-lg",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "row col-md-2" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_29 = {
  style: {"float":"right !important","position":"relative"},
  id: "chart",
  class: "col-md-5"
}
const _hoisted_30 = {
  style: {"margin-left":"10% !important"},
  class: "\n                  nav nav-stretch\n                  fs-5\n                  fw-bold\n                  nav-line-tabs nav-line-tabs-2x\n                  border-transparent\n                ",
  role: "tablist"
}
const _hoisted_31 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chart-pie fa-lg fa-border-none",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "nav-item" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-undo fa-lg",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  id: "chart1",
  class: "col-md-6"
}
const _hoisted_38 = { class: "row col-md-12" }
const _hoisted_39 = { class: "col-md-5" }
const _hoisted_40 = {
  style: {},
  id: "divProfileType"
}
const _hoisted_41 = {
  id: "spanShowDetails",
  style: {"cursor":"pointer","padding-left":"40%"}
}
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Profile types ")
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sort-down card-label card-title" }, null, -1)
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<table class=\"\n                  table table-striped table-bordered table-advance table-hover\n                \"><tbody><tr><td style=\"text-align:left !important;\"><div style=\"color:rgb(237, 28, 36);background-color:rgb(237, 28, 36);font-size:2px;\"> | </div> 00 </td><td class=\"hidden-xs\"> Half-hourly supply (import and export) </td></tr><tr><td style=\"text-align:center;\"><div style=\"color:rgb(0, 134, 170);background-color:rgb(0, 134, 170);font-size:2px;\"> | </div> 01 </td><td class=\"hidden-xs\">Domestic Unrestricted</td></tr><tr><td style=\"text-align:center;\"><div style=\"color:rgb(145, 39, 143);background-color:rgb(145, 39, 143);font-size:2px;\"> | </div> 02 </td><td class=\"hidden-xs\"> Domestic Economy Meter of 2 or more rates </td></tr><tr><td style=\"text-align:center;\"><div style=\"color:rgb(140, 198, 63);background-color:rgb(140, 198, 63);font-size:2px;\"> | </div> 03 </td><td class=\"hidden-xs\">Domestic Unrestricted</td></tr><tr><td style=\"text-align:center;\"><div style=\"color:rgb(46, 49, 146);background-color:rgb(46, 49, 146);font-size:2px;\"> | </div> 04 </td><td class=\"hidden-xs\">Non-Domestic Economy 7</td></tr><tr><td style=\"text-align:center;\"><div style=\"color:rgb(235, 236, 237);background-color:rgb(235, 236, 237);font-size:2px;\"> | </div> 05 </td><td class=\"hidden-xs\"> Non-domestic, with MD recording capability and with LF less than or equal to 20% </td></tr><tr><td style=\"text-align:center;\"><div style=\"color:rgb(113, 125, 189);background-color:rgb(113, 125, 189);font-size:2px;\"> | </div> 06 </td><td class=\"hidden-xs\"> Non-domestic, with MD recording capability and with LF less than or equal to 30% and greater than 20% </td></tr><tr><td style=\"text-align:center;\"><div style=\"color:rgb(244, 132, 115);background-color:rgb(244, 132, 115);font-size:2px;\"> | </div> 07 </td><td class=\"hidden-xs\"> Non-domestic, with MD recording capability and with LF less than or equal to 40% and greater than 30% </td></tr><tr><td style=\"text-align:center;\"><div style=\"color:rgb(255, 203, 5);background-color:rgb(255, 203, 5);font-size:2px;\"> | </div> 08 </td><td class=\"hidden-xs\"> Non-domestic, with MD recording capability and with LF greater than 40% (also all NHH export MSIDs) </td></tr></tbody></table>", 1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 2,
  style: {},
  id: "loadingDiv"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, "Loading...", -1)
const _hoisted_51 = [
  _hoisted_50
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_TableTab = _resolveComponent("TableTab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, [
                _createElementVNode("input", {
                  type: "radio",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAssetAddition && _ctx.openAssetAddition(...args))),
                  name: "tab-input",
                  class: "tab-input"
                }),
                _hoisted_10
              ]),
              _createElementVNode("label", _hoisted_11, [
                _createElementVNode("input", {
                  type: "radio",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAssetRemoval && _ctx.openAssetRemoval(...args))),
                  name: "tab-input",
                  class: "tab-input"
                }),
                _hoisted_12
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.addition)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("ul", _hoisted_21, [
                      _createElementVNode("li", _hoisted_22, [
                        _createElementVNode("button", {
                          id: "kt_referrals_year_tab",
                          "data-bs-toggle": "tab",
                          role: "tab",
                          class: "nav-link text-active-primary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeChartType('line'))),
                          title: "line chart"
                        }, _hoisted_24)
                      ]),
                      _createElementVNode("li", _hoisted_25, [
                        _createElementVNode("button", {
                          id: "kt_referrals_year_tab",
                          role: "tab",
                          "data-bs-toggle": "tab",
                          class: "nav-link text-active-primary",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeChartType('bar'))),
                          title: "Reset chart"
                        }, _hoisted_27)
                      ])
                    ]),
                    _createVNode(_component_apexchart, {
                      width: "450",
                      type: _ctx.ebchartType,
                      options: _ctx.eboptions,
                      series: _ctx.eboptions.series
                    }, null, 8, ["type", "options", "series"])
                  ]),
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("ul", _hoisted_30, [
                      _createElementVNode("li", _hoisted_31, [
                        _createElementVNode("button", {
                          id: "kt_referrals_year_tab",
                          "data-bs-toggle": "tab",
                          role: "tab",
                          class: "nav-link text-active-primary",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeGasChartType('line'))),
                          title: "Pie chart"
                        }, _hoisted_33)
                      ]),
                      _createElementVNode("li", _hoisted_34, [
                        _createElementVNode("button", {
                          id: "kt_referrals_year_tab",
                          role: "tab",
                          "data-bs-toggle": "tab",
                          class: "nav-link text-active-primary",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeGasChartType('bar'))),
                          title: "Reset chart"
                        }, _hoisted_36)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_apexchart, {
                        width: "450",
                        type: _ctx.gaschartType,
                        options: _ctx.gasoptions,
                        series: _ctx.gasoptions.series
                      }, null, 8, ["type", "options", "series"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("span", _hoisted_41, [
                        _createElementVNode("a", {
                          class: "card-label card-title",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showprofileType()))
                        }, _hoisted_44)
                      ])
                    ])
                  ]),
                  (_ctx.showprofile == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.removal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createVNode(_component_TableTab, {
            key: _ctx.tableValues.length,
            "table-data": _ctx.tableValues,
            "table-header": _ctx.OriginalTableHeaders,
            "enable-items-per-page-dropdown": true,
            selectedType: _ctx.colnames,
            pagetitle: _ctx.pageheader,
            downloadUrl: _ctx.downloadurl,
            downloadprops: _ctx.downloadprops,
            isTemplateDownload: true
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.colnames, (slot) => {
              return {
                name: `cell-${slot}`,
                fn: _withCtx(({ row: customer }) => [
                  _createTextVNode(_toDisplayString(customer[slot]), 1)
                ])
              }
            })
          ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle", "downloadUrl", "downloadprops"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
      : _createCommentVNode("", true)
  ], 64))
}